import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ClipboardCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WorklistPanel } from "@/components/checkins/staff/WorklistPanel";
import { DuePanel } from "@/components/checkins/staff/DuePanel";
import { ReportsPanel } from "@/components/checkins/staff/ReportsPanel";
import { TemplatesPanel } from "@/components/checkins/staff/TemplatesPanel";
import { SettingsPanel } from "@/components/checkins/staff/SettingsPanel";

const LEADS = ["owner", "manager", "administration"];

export default function Checkins() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [staff, setStaff] = useState([]);
  const [tab, setTab] = useState(params.get("tab") || "worklist");
  useEffect(() => { api.get("/checkin-staff").then((r) => setStaff(r.data)).catch(() => {}); }, []);
  const isLead = LEADS.includes(user?.role);
  const readOnly = user?.role === "auditor";
  return (
    <div className="space-y-6" data-testid="checkins-page">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-600">Client care</div>
        <h1 className="mt-2 flex items-center gap-3 font-display text-3xl font-bold tracking-tight text-zinc-950 sm:text-4xl">
          <ClipboardCheck className="h-7 w-7 text-zinc-500" /> Progress Review
        </h1>
        <p className="mt-2 max-w-2xl text-sm text-zinc-600">Safety, red, review and contact items from client progress reviews. Routine results update each client&apos;s record without creating tasks.</p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="checkins-tabs">
          <TabsTrigger value="worklist" data-testid="checkins-tab-worklist">Worklist</TabsTrigger>
          <TabsTrigger value="due" data-testid="checkins-tab-due">Due</TabsTrigger>
          <TabsTrigger value="reports" data-testid="checkins-tab-reports">Reports</TabsTrigger>
          <TabsTrigger value="templates" data-testid="checkins-tab-templates">Templates</TabsTrigger>
          <TabsTrigger value="settings" data-testid="checkins-tab-settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="worklist" className="pt-4"><WorklistPanel staff={staff} me={user} readOnly={readOnly} highlightId={params.get("alert")} /></TabsContent>
        <TabsContent value="due" className="pt-4"><DuePanel /></TabsContent>
        <TabsContent value="reports" className="pt-4"><ReportsPanel /></TabsContent>
        <TabsContent value="templates" className="pt-4"><TemplatesPanel isLead={isLead} /></TabsContent>
        <TabsContent value="settings" className="pt-4"><SettingsPanel isLead={isLead} /></TabsContent>
      </Tabs>
    </div>
  );
}
